import styled from 'styled-components'

export const ResetPassWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PassInnerWrapper = styled.div`
  width: 500px;
  padding: 50px;
  background: white;
  border-radius: 10px;
  animation: display;
  animation-duration: 1s;
`

export const LogoWrapper = styled.div`
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  color: var(--dark);
  font-weight: 500;
  cursor: pointer;
`
